/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnerscolumncreated2Inputs */

const en_partnerscolumncreated2 = /** @type {(inputs: Partnerscolumncreated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Added`)
};

const de_partnerscolumncreated2 = /** @type {(inputs: Partnerscolumncreated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angelegt`)
};

/**
* | output |
* | --- |
* | "Added" |
*
* @param {Partnerscolumncreated2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnerscolumncreated2 = /** @type {((inputs?: Partnerscolumncreated2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnerscolumncreated2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnerscolumncreated2(inputs)
	return de_partnerscolumncreated2(inputs)
});
export { partnerscolumncreated2 as "partnersColumnCreated" }